import React, { Component } from 'react';
import { clone, map, pipe, toString } from 'ramda';
import { gqlOperation, logError, saveHandler, toAwsJson } from '../../../../common/utils';
import { GetPrices, CreateMyPayment, CreateMyPurcaseOrder } from './graphql';

const withPayment = (WrappedComponent) =>  {

  class HOC extends Component {

    handlePaypalSuccess = (payment, teams, total, subtotal, tax, callback) => {
      saveHandler({
        teamIds:  map(({ teamId }) => teamId, clone(teams)).join(','),
        data: JSON.stringify(payment),
        total: total + '',
        subtotal: subtotal + '',
        tax: tax + '',
        success: true
      }, [], CreateMyPayment, () => {
        callback();
      });
    };

    handleZeroPayment = (teams, callback) => {
      saveHandler({
        teamIds:  map(({ teamId }) => teamId, clone(teams)).join(','),
        total: 0,
        subtotal: 0,
        tax: 0,
        success: true
      }, [], CreateMyPayment, () => {
        callback();
      });
    };

    handlePaypalError = (err) => {
      logError(err);
    };

    handleCreatePurchaseOrder = (invoice, teams, callback) => {
      const data = clone(invoice);
      data.teams = toAwsJson(teams);

      data.teamIds = map(({ teamId }) => teamId, clone(teams)).join(',');
      saveHandler(data, [], CreateMyPurcaseOrder, () => {
        callback();
      });
    };

    calculatePrices = (data, coupons, callback) => {
      let competitions = pipe(
        clone(),
        map(c => {
          return {
            competitionId: c.competition.id,
            eventId: c.eventId
          };
        }),
        toString
      )(data);

      gqlOperation(GetPrices, { competitions: competitions, coupons: coupons })
        .then(({ getPrices }) => {

          const calc = pipe(
            clone(),
            map(team => {
              var priceMatch = getPrices.find(({ competitionId }) => competitionId === team.competition.id);
              //var priceMatch = find(propEq('competitionId', team.competitionId), getPrices);
              team.orig_price = parseFloat(priceMatch.orig_price);
              team.discount = parseFloat(priceMatch.discount);
              team.sale_price = parseFloat(priceMatch.sale_price);
              team.tax = parseFloat(priceMatch.tax);
              team.total = parseFloat(priceMatch.total);
              return team;
            })
          )(data);

          callback(calc);
        })
        .catch(logError);
    };
    
    render() {
      return (
        <WrappedComponent
          savePaypalSuccess={this.handlePaypalSuccess}
          savePaypalError={this.handlePaypalError}
          createPurchaseOrder={this.handleCreatePurchaseOrder}
          calculatePrices={this.calculatePrices}
          saveZeroPayment={this.handleZeroPayment}
          {...this.props}
        />
      );
    }
  };

  return HOC;
};

export default withPayment;



// WEBPACK FOOTER //
// ./src/private/user/containers/Payment/index.js